import * as Clipboard from 'expo-clipboard';
import * as Random from 'expo-random';
import * as Sharing from 'expo-sharing';
import {Toast} from 'native-base';
import {Alert, Platform, Share} from 'react-native';
import {t} from 'react-native-tailwindcss';
import i18n from './i18n';

export const getStatusStyle = (isIncome: boolean) => {
  return isIncome ? t.textGreen500 : t.textGray500;
};

export const shareUrl = async (url: string) => {
  if (Platform.OS === 'web') {
    if (await Sharing.isAvailableAsync()) {
      await Sharing.shareAsync(url);
      return;
    }
    Clipboard.setString(url);
    Toast.show({
      description: i18n.t('copied'),
      duration: 1500
    });
    return;
  }
  try {
    const options = Platform.OS === 'ios' ? {url} : {message: url};

    await Share.share({
      title: i18n.t('sharePayment'),
      ...options
    });
  } catch (error) {
    if (error instanceof Error) {
      Alert.alert('Error', error.message);
    }
  }
};

/**
 * Generates a hex random string
 * @param size: number
 */

export const randomHex = (size: number) => {
  return [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
};

export const localeMap = (deviceLocale = i18n.currentLocale()) => {
  switch (deviceLocale) {
    case 'es-ES':
    case 'ca-ES':
      return 'es-es';
  }
  return 'en-us';
};

export const intToHex = (nr: number) => nr.toString(16).padStart(2, '0');

export const getRandomString = (bytes: number) => {
  Random.getRandomBytes(bytes);
  return Array.from(Random.getRandomBytes(bytes)).map(intToHex).join('');
};

export const truncateHash = (hash: string | null | undefined) => {
  if (!hash) return null;
  return `${hash.slice(0, 6)}...${hash.slice(-6)}`;
};

export const parseJSON = <T>(json: string) => {
  try {
    return JSON.parse(json) as T;
  } catch (e) {
    return null;
  }
};
